export const maskEmail = (
  email?: string,
  abbreviationIndex?: number
): string => {
  if (!email) {
    return "";
  }

  const [local, domain] = email.split("@");
  const [firstName, ...surnameParts] = local.split(".");

  if (!surnameParts.length) {
    const visibleCount = (abbreviationIndex || 0) + 1;
    const maskedLocal = local
      .split("")
      .map((char, index) => (index < visibleCount ? char : "*"))
      .join("");

    return `${maskedLocal}@${domain}`;
  }

  // Join surname parts with dots
  const surnameWithDots = surnameParts.join(".");
  let count = 0;
  const maskedSurname = surnameWithDots
    .split("")
    .map((char) => {
      let result: string;

      if (count <= (abbreviationIndex || 0)) {
        result = char; // keep visible
      } else {
        result = char === "." ? "." : "*"; // mask letters only
      }

      count++;
      return result;
    })
    .join("");

  return `${firstName}.${maskedSurname}@${domain}`;
};
